window.VennApps = {
  postAddCartLine(payload) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.addCartLine
    ) {
      window.webkit.messageHandlers.addCartLine.postMessage(payload);
      return true;
    }

    if (window.JavaInterface) {
      if (typeof window.JavaInterface.addCartLine === "function") {
        window.JavaInterface.addCartLine(JSON.stringify(payload));
        return true;
      }
    }
    return false;
  }
};
